import React, { createContext } from "react";

type Page = 'home' | 'responses';

interface NavigationState {
    page: Page,
    args: Record<string, string>,
}
interface NavigationContext extends NavigationState {
    navigate: (page: Page, args?: Record<string, string>) => void
}

const navigationContext = createContext<NavigationContext>({
    page: 'home',
    args: {},
    navigate: () => { },
})

export const useNavigation = () => React.useContext(navigationContext);

interface Props {
    children: React.ReactNode
}

export const NavigationContextProvider = (props: Props) => {
    const [state, setState] = React.useState<NavigationState>({
        page: 'home',
        args: {},
    });

    const navigate = (page: Page, args?: Record<string, string>) => {
        setState({
            page,
            args: args || {},
        })
    }

    return <navigationContext.Provider value={{ ...state, navigate }}>
        {props.children}
    </navigationContext.Provider>
}
